import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { Link } from "react-scroll";
import { motion } from "framer-motion";
import { FaFileAlt } from "react-icons/fa";
import { impactStats, profile } from "../../constants";
import SocialIcons from "../layouts/SocialIcons";
import { iconFor } from "../layouts/techIcons";
import CountUp from "../layouts/CountUp";

const heroSkills = ["AWS", "OpenAI", "React", "Node.js", "NestJS", "PostgreSQL"];

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: [
        "Senior Full-Stack Engineer.",
        "AI Integration Builder.",
        "AWS Serverless Engineer.",
        "Customer-Facing Problem Solver.",
      ],
      loop: true,
      typeSpeed: 40,
      deleteSpeed: 20,
      delaySpeed: 2000,
    });
  return (
    <motion.div
      initial={{ opacity: 0, x: -40 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="w-full lgl:w-[55%] flex flex-col gap-10 relative z-10"
    >
      <div className="flex flex-col gap-6">
        {profile.availability && (
          <span className="self-start inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-green-400/30 bg-green-400/10 text-xs sm:text-sm text-green-300">
            <span className="relative flex w-2 h-2 shrink-0">
              <span className="absolute inline-flex w-full h-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
              <span className="relative inline-flex w-2 h-2 rounded-full bg-green-400"></span>
            </span>
            {profile.availability}
          </span>
        )}
        <div>
          <p className="text-lg text-gray-400 mb-2">Hello, I'm</p>
          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight">
            <span className="gradientText">{profile.name}</span>
          </h1>
        </div>
        <h2 className="text-2xl md:text-4xl font-bold text-white min-h-[1.5em]">
          <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-sm uppercase tracking-[3px] text-designColor -mt-2">{profile.headline}</p>
        <p className="text-base md:text-lg font-bodyFont leading-8 tracking-wide text-gray-400 max-w-xl">
          {profile.tagline}
        </p>
        <div className="flex flex-wrap gap-4 mt-2">
          <Link
            to="contact"
            smooth={true}
            offset={-70}
            duration={500}
            className="px-8 py-3 rounded-full bg-designColor text-white font-medium tracking-wide cursor-pointer shadow-lg shadow-designColor/30 hover:-translate-y-1 hover:shadow-designColor/50 duration-300"
          >
            Let's Talk
          </Link>
          <Link
            to="experience"
            smooth={true}
            offset={-70}
            duration={500}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-gray-600 text-gray-300 font-medium tracking-wide cursor-pointer hover:border-designColor hover:text-designColor hover:-translate-y-1 duration-300"
          >
            <FaFileAlt className="text-sm" /> View Experience
          </Link>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-2xl">
        {impactStats.map(({ value, label }) => (
          <div key={label} className="card px-3 py-5 text-center">
            <p className="text-2xl md:text-3xl font-bold text-white"><CountUp value={value} /></p>
            <p className="text-[11px] leading-4 text-gray-400 mt-2">{label}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-col sml:flex-row gap-8 sml:gap-12">
        <div>
          <h2 className="text-xs uppercase tracking-[3px] text-gray-500 mb-4">
            Find me on
          </h2>
          <SocialIcons />
        </div>
        <div>
          <h2 className="text-xs uppercase tracking-[3px] text-gray-500 mb-4">
            Core stack
          </h2>
          <div className="flex flex-wrap gap-3">
            {heroSkills.map((name) => (
              <span key={name} className="bannerIcon" title={name} aria-label={name}>
                {iconFor(name)}
              </span>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default LeftBanner
